import styled from 'styled-components';

export const Main = styled.div`
    background-color: #fff;
    border-radius: 30px 30px 0 0;

    @media (min-width: 768px) {
        border-radius: 30px;
        margin-bottom: 60px;
    }
`;
